Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "MembersWidget987538873",
  {"root":"MembersWidget987538873--root","list":"MembersWidget987538873--list","member":"MembersWidget987538873--member","empty":"MembersWidget987538873--empty Box454630030--description","description":"Box454630030--description","memberWrapper":"MembersWidget987538873--memberWrapper","ctaButtonWrapper":"MembersWidget987538873--ctaButtonWrapper"},
  "",
  8,
  "MembersWidget987538873"
);

